// Module
var code = "<a class=\"intercom-launcher\" title=\"Contact Support\" ng-class=\"{'round-badge': $ctrl.showBadge, 'isMobile': $ctrl.isMobile}\" ng-attr-data-badge=\"{{$ctrl.unreadCount}}\" ng-click=\"$ctrl.onSupportClick()\"> <i class=\"fa-light fa-comment\" aria-hidden=\"true\"></i> </a> ";
// Exports
export default code;